interface IIconProps {
  size?: number;
  color?: string;
  circleColor?: string;
}

export const DentalAssistantIcon = ({ size = 46, color = '#83B2BE', circleColor = '#E7F0F3' }: IIconProps) => (
  <svg width={size} height={size} viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="22.8571" cy="22.8571" r="22.8571" fill={circleColor} />
    <path
      d="M22.8569 9.34961C25.1589 9.34961 27.0317 11.2224 27.0317 13.5244C27.0317 15.4913 25.6648 17.1432 23.8315 17.583V22.2559H25.4321V24.4727H20.2817V22.2559H21.8823V17.583C20.049 17.1432 18.6821 15.4913 18.6821 13.5244C18.6821 11.2224 20.555 9.34961 22.8569 9.34961Z"
      fill={color}
      stroke={color}
      strokeWidth="0.35"
    />
    <path
      d="M25.4316 27.0557V34.4307C25.4315 35.8503 24.277 37.0056 22.8574 37.0059C21.4376 37.0059 20.2823 35.8504 20.2822 34.4307V27.0557H25.4316Z"
      fill={color}
      stroke={color}
      strokeWidth="0.35"
    />
    <path
      d="M33.4316 27.0557V34.4307C33.4315 35.8503 32.277 37.0056 30.8574 37.0059C29.4376 37.0059 28.2823 35.8504 28.2822 34.4307V27.0557H33.4316Z"
      fill={color}
      stroke={color}
      strokeWidth="0.35"
    />
    <path
      d="M17.4316 27.0557V34.4307C17.4315 35.8503 16.277 37.0056 14.8574 37.0059C13.4376 37.0059 12.2823 35.8504 12.2822 34.4307V27.0557H17.4316Z"
      fill={color}
      stroke={color}
      strokeWidth="0.35"
    />
    <path
      d="M10.8569 9.34961C13.6005 9.34961 15.8314 11.5807 15.8315 14.3242V22.2559H17.4321V24.4727H12.2817V22.2559H13.8823V14.3242C13.8822 12.6567 12.5245 11.2998 10.8569 11.2998H10.6821V9.34961H10.8569Z"
      fill={color}
      stroke={color}
      strokeWidth="0.35"
    />
    <path
      d="M32.457 9.34961C33.1801 9.34961 33.8251 9.71645 34.2852 10.2471C34.7449 10.7774 35.0322 11.4841 35.0322 12.1914C35.0321 12.8986 34.7449 13.6055 34.2852 14.1357C33.8251 14.6662 33.1799 15.0332 32.457 15.0332H31.832V22.2559H33.4316V24.4727H28.2822V22.2559H29.8818V13.0908H32.4336C32.763 13.0032 32.9154 12.8229 32.9941 12.6221C33.0801 12.4025 33.082 12.1503 33.082 11.9248C33.082 11.5804 32.8014 11.2998 32.457 11.2998H28.2822V9.34961H32.457Z"
      fill={color}
      stroke={color}
      strokeWidth="0.35"
    />
  </svg>
);
